<template>
    <div class="modal fade" id="addonsModal" ref="addonsModal" tabindex="-1" aria-labelledby="addonsModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!px-3 tablet:!px-0 mobile:!max-w-full tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content">
                <div class="mobile:!p-2.5 tablet:!p-3 !pb-5">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div
                            class="rounded-lg overflow-hidden h-[80px] bg-customBlue-100 flex flex-col justify-center gap-1 p-3 w-full">
                            <h4 class="text-xl font-normal font-roboto m-0 text-white">
                                Optional Coverages
                            </h4>
                        </div>
                    </div>
                    <div ref="scrollBox" class="font-roboto max-h-[550px] overflow-y-auto customScrollbar mt-3 smallMobile:pr-[5px] pr-[10px]">
                        <p class="px-[5px] mb-[20px] text-[14px] font-roboto text-[#666666] text-justify">
                            Enhance your protection with optional add-ons.
                            Choose extra coverage for greater peace of mind.
                            Tailor your plan to fit your home perfectly.</p>
                        <div v-for="data in addOnData" :key="data.id"
                            class="py-[10px] px-[5px] flex flex-col gap-[5px] border-b border-[#EFEFEF]">
                            <div class="flex items-center justify-between">
                                <div class="flex items-center smallMobile:gap-1 gap-2.5">
                                    <label class="flex items-center smallMobile:!gap-1.5 gap-2 cursor-pointer select-none ">
                                        <input @click="onCheckboxClick(data)" type="checkbox" v-model="data.checked"
                                            class="hidden peer" />
                                        <div
                                            class="smallMobile:w-[26px] w-[30px] smallMobile:h-[26px] h-[30px] rounded-[5px] flex items-center justify-center transition border border-[#CCCCCC] peer-checked:!border-customBlue-100">
                                            <svg v-if="data.checked" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 20 20" fill="#2459A8" class="w-[20px] h-[20px]">
                                                <path fill-rule="evenodd"
                                                    d="M16.707 5.293a1 1 0 0 1 0 1.414l-7.5 7.5a1 1 0 0 1-1.414 0l-3.5-3.5a1 1 0 1 1 1.414-1.414L8.5 11.086l6.793-6.793a1 1 0 0 1 1.414 0z"
                                                    clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                        <span class="smallMobile:text-[12px] text-[14px] font-roboto text-[#333]">
                                            {{ data.bundle_name }}
                                        </span>
                                    </label>
                                    <!-- v-if="addonsInfoImg" @click="infoClicked(plan)" -->
                                    <img @click="infoClicked(data.plans)"
                                        src="../../../assets/images/plan-info.svg" alt="Check Icon"
                                        class="w-[22px] h-[22px] cursor-pointer">
                                </div>
                                <div>
                                    <h6 class="m-0 smallMobile:text-[12px] text-[14px] text-customYellow-100"> {{ data.months }} months</h6>
                                    <h2 class="m-0 smallMobile:text-[14px] text-base tablet:text-[18px] font-bold font-roboto text-[#333]">${{
                                        $helper.formatAmount(data.amount) }}/mo
                                    </h2>
                                </div>
                            </div>
                            <div class="flex items-center tablet:items-end justify-between">
                                <quantityCounter class="w-max" v-if="((data.is_show_quantity == '1'))"
                                    :quantity="data.quantity" @update-counter="updateCounter" :product="data"
                                    :disabled="data.quantity <= 0" />
                                <h2 v-if="data.checked && data.quantity > 1"
                                    class="m-0 smallMobile:text-[14px] text-[16px] font-bold font-roboto text-customBlue-100">${{
                                        $helper.formatAmount(data.amount * data.quantity) }}/mo
                                </h2>
                            </div>
                        </div>
                        <div v-if="!isFromCheckout" class="flex items-center justify-center gap-[10px] mt-4">
                            <!-- <button @click="skipClicked"
                                class="px-[30px] py-[6px] text-[14px] rounded-[5px] border-[1px] border-customBlue-100 text-cusborder-customBlue-100"
                                data-bs-dismiss="modal">
                                Skip
                            </button> -->
                            <button @click="checkoutclicked"
                                class="px-[15px] py-[8px] text-[14px] font-medium font-roboto rounded-[5px] CustomBlueBtn mb-1.5">
                                Proceed to Checkout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import quantityCounter from "../../partialComponent/quantityCounter.vue";
import { mapActions, mapGetters } from "vuex";


export default {
    data() {
        return {
            checked: false,
            route_slug: 'add-on',
            addOnData: [],
            isCartUpdated: false,
            isWatcherDisolve: false
        };
    },
    props: {
        bundle: Object,
        updateCart: Function,
        isFromCheckout: {
            type: Boolean,
            default: false
        },
        // isWatcherDisolve: {
        //     type: Boolean,
        //     default: false
        // },
    },
    components: {
        quantityCounter
    },

    computed: {
        ...mapGetters([
            "protectionPlanBundleAddons",
            "selectedProtectionPlan",
            "cartUpdated",
            "cartCountResponse"
        ]),

    },
    watch: {
        protectionPlanBundleAddons: function (data) {

            const updatedBundles = data.map(bundle => ({
                ...bundle,
                checked: bundle.quantity > 0
            }));

            this.isCartUpdated = false
            this.addOnData = updatedBundles
            if (this.modal || this.isWatcherDisolve) return
            const modalEl = this.$refs.addonsModal;

            // Create bootstrap modal
            this.modal = new Modal(modalEl, { backdrop: 'static' });
            document.documentElement.style.overflow = 'hidden';
            this.adjustPlanModalHeight();
            window.addEventListener('resize', this.adjustPlanModalHeight);
            window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            // Fix scroll restore on close
            modalEl.addEventListener("hidden.bs.modal", () => {
                document.documentElement.classList.remove("overflow-hidden");
                document.documentElement.style.overflow = '';
                this.modal = null
                window.addEventListener('resize', this.adjustPlanModalHeight);
                window.addEventListener('orientationchange', this.adjustPlanModalHeight);
            });

            modalEl.addEventListener("shown.bs.modal", () => {
                if (this.$refs.scrollBox) {
                    this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                }
            });


            if (window.innerWidth > 992) {
                document.documentElement.classList.add("overflow-hidden");
            }
            this.modal.show();



            this.$nextTick(() => {
                this.$refs.scrollBox.scrollTop = 0;
            });


        },

        cartUpdated: function (data) {

            if (!this.modal) return
            this.isCartUpdated = true
            this.isWatcherDisolve = true
            this.getProtectionPlansBundleAddons({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.route_slug });
        },

        cartCountResponse: function (data) {
            if (!this.cartCountResponse['myhappyhome-bundle'] || this.cartCountResponse['myhappyhome-bundle'] == 0) {
                this.closeModal()
            }

        },

    },

    mounted() {

    },

    unmounted() {
        document.documentElement.classList.remove("overflow-hidden");
    },

    methods: {

        ...mapActions([
            "getProtectionPlansBundleAddons",
            "upsertCart",
            "getAddonPlanDetails",

        ]),
        infoClicked(item) {

            let plan_ =  item[0]
            this.getAddonPlanDetails({
                id: plan_.plan_id
            })
        },
        onCheckboxClick(data) {
            data.checked = !data.checked;


            this.upsertCart({
                "bundle_id": data.id,
                "quantity": data.checked ? 1 : 0,
                "partner_id": data.partner_id ? data.partner_id : this.selectedProtectionPlan.partner_id
            })
        },

        openModal() {
            this.isWatcherDisolve = false
            this.getProtectionPlansBundleAddons({ 'partner_id': this.selectedProtectionPlan.partner_id, "route_slug": this.route_slug });
            // Tailwind way → disable scroll

        },

        closeModal() {
            if (this.modal == null) return
            // Tailwind way → enable scroll
            if (window.innerWidth > 992) {
                document.documentElement.classList.remove("overflow-hidden");
            }

            this.modal.hide();
        },

        updateCounter(option, data) {

            let quantity = data?.quantity ?? 0

            if (option == "increment") {

                quantity = quantity + 1

            } else if (option == "decrement" || option == "remove") {

                quantity = quantity - 1

                if (quantity <= 0) {
                    quantity = 0
                }
            }

            this.upsertCart({
                "bundle_id": data.id,
                "quantity": quantity,
                "partner_id": data.partner_id ? data.partner_id : this.selectedProtectionPlan.partner_id
            })
        },

        checkoutclicked() {
            document.documentElement.classList.remove("overflow-hidden");
            this.modal = null
            this.$router.push({
                name: 'partnerCheckout'
            })
        },
        adjustPlanModalHeight() {
            const modalContent = this.$refs.scrollBox;
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 300) {
                    maxHeight = vh * 0.5 - 40;
                } else if (vw < 768) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 991) {
                    maxHeight = vh * 0.8 - 50;
                } else if (vw < 1440) {
                    maxHeight = vh * 0.8 - 50;
                }
                else {
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },

    },
};
</script>
